export default "__VITE_ASSET__dafe0348__"